const priorities = {
    "-1": 'Normal + High',
    "1": 'Normal',
    "2": 'High',
    "0": 'Low',
};
export default priorities;